<template>
    <section class="page-wrap error-page pt-0">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xxl-6 col-lg-6">
              <div class="text-center">
                <img src="../assets/images/404.svg" class="img-fluid" alt="404 Error">
                <div class="rollback-btn">
                  <p class="mb-0">Page not found</p>
                  <button @click="routeToHome"
                          class="backHome mt-4">
                    Back to Homepage
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  </template>

  <script>
export default  {
    name: 'NotFound',
    methods: {
      routeToHome () {
        let app = this;
        localStorage.clear();
        app.$store.dispatch("isRepAuthenticated", false);
        app.$store.dispatch("landingInfo", null);
        app.$store.dispatch("landingUrl", '');
        app.$store.dispatch("repInfo", null);
        app.$store.dispatch("groupInfo", null);
        app.$store.dispatch("continueEnrollmentInfo", false);
        app.$store.commit('MUTATION_SET_ERROR', false);
        app.$store.dispatch('isHomePageRedirect', false)
        app.$store.dispatch('innerLandingUrl', '')

        // Clear url and redirect to Domain
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const baseDomain = urlObj.origin;
        window.location.href = baseDomain;
      }
    }
  }
</script>